import { render, staticRenderFns } from "./DSConfirmButton.vue?vue&type=template&id=6f0e40d9&scoped=true&"
import script from "./DSConfirmButton.vue?vue&type=script&lang=js&"
export * from "./DSConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./DSConfirmButton.vue?vue&type=style&index=0&id=6f0e40d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e40d9",
  null
  
)

export default component.exports